import { Stack, TextField } from '@mui/material';
import { CuriosityAutocomplete, CuriosityNamespaceType } from '@procureai/curiosity-ui-mui';
import { Controller, DefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RuleVariantOption } from '../../hooks/useRuleDialogActions/useRuleDialogActions';
import { RuleDetailDialogFormData } from '../RuleDetailDialog/RuleDetailDialog.schema';
import { I18nNamespace } from '~/common/types';
import { VariantSelect } from '~/components/VariantSelect/VariantSelect';
import { useFormFieldErrorTranslation } from '~/hooks';

interface RuleDetailDialogFormFieldsProps {
  id?: string;
  variantOptions: RuleVariantOption[];
  defaultValues: DefaultValues<RuleDetailDialogFormData>;
}

export const RuleDetailDialogFormFields = ({ id, variantOptions, defaultValues }: RuleDetailDialogFormFieldsProps) => {
  const { t } = useTranslation(I18nNamespace.ruleBuilder, { keyPrefix: 'RuleDetailDialog' });
  const { errorToHelperText } = useFormFieldErrorTranslation();
  return (
    <Stack spacing={5}>
      <Controller
        name="name"
        defaultValue={defaultValues.name}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              label={t('name')}
              error={!!error}
              helperText={errorToHelperText(error)}
              {...field}
              value={field.value || ''}
            />
          );
        }}
      />
      <Controller
        name="responsibleUsers"
        defaultValue={defaultValues.responsibleUsers}
        render={({ field, fieldState: { error } }) => (
          <CuriosityAutocomplete
            {...field}
            value={field.value ?? null}
            multiple
            simplifyValue
            ns={CuriosityNamespaceType.INTERNAL_USER}
            error={!!error}
            TextFieldProps={{
              label: t('responsibleUsers'),
              error: !!error,
              helperText: errorToHelperText(error),
            }}
          />
        )}
      />
      <Controller
        name="variant"
        defaultValue={defaultValues.variant}
        render={({ field, fieldState: { error } }) => (
          <VariantSelect
            {...field}
            disabled={!!id}
            label={t('variant')}
            options={variantOptions}
            error={!!error}
            helperText={errorToHelperText(error)}
          />
        )}
      />
    </Stack>
  );
};
